const EFFECTS = {
  answerOk: [
    { frequency: 523.25, start: 0, duration: 0.18, type: 'sine', gain: 0.09 },
    { frequency: 659.25, start: 0.13, duration: 0.18, type: 'sine', gain: 0.085 },
    { frequency: 783.99, start: 0.26, duration: 0.3, type: 'sine', gain: 0.075 },
  ],
  answerNo: [
    { frequency: 196, start: 0, duration: 0.28, type: 'triangle', gain: 0.075 },
    { frequency: 293.66, start: 0, duration: 0.2, type: 'sine', gain: 0.025 },
  ],
  cardFlip: [
    { frequency: 520, start: 0, duration: 0.055, type: 'triangle', gain: 0.035 },
    { frequency: 320, start: 0.025, duration: 0.07, type: 'sine', gain: 0.025 },
  ],
  repeat: [
    { frequency: 520, start: 0, duration: 0.055, type: 'triangle', gain: 0.055 },
    { frequency: 780, start: 0.045, duration: 0.07, type: 'sine', gain: 0.045 },
  ],
  autoRepeat: [
    { frequency: 150, start: 0, duration: 0.08, type: 'sawtooth', gain: 0.045 },
    { frequency: 310, start: 0.04, duration: 0.12, type: 'triangle', gain: 0.06 },
    { frequency: 620, start: 0.12, duration: 0.12, type: 'triangle', gain: 0.055 },
    { frequency: 930, start: 0.2, duration: 0.16, type: 'sine', gain: 0.05 },
  ],
  attackSuccess: [
    { frequency: 523.25, start: 0, duration: 0.07, type: 'triangle', gain: 0.065 },
    { frequency: 783.99, start: 0.045, duration: 0.09, type: 'triangle', gain: 0.062 },
    { frequency: 1046.5, start: 0.11, duration: 0.13, type: 'sine', gain: 0.052 },
    { frequency: 1318.51, start: 0.18, duration: 0.16, type: 'sine', gain: 0.036 },
  ],
  attackDamage: [
    { frequency: 118, start: 0, duration: 0.16, type: 'sawtooth', gain: 0.075 },
    { frequency: 82, start: 0.035, duration: 0.2, type: 'square', gain: 0.052 },
    { frequency: 236, start: 0.018, duration: 0.09, type: 'sawtooth', gain: 0.058 },
    { frequency: 54, start: 0.11, duration: 0.25, type: 'triangle', gain: 0.07 },
  ],
  celebration: [
    { frequency: 523.25, start: 0, duration: 0.09, type: 'triangle', gain: 0.055 },
    { frequency: 659.25, start: 0.08, duration: 0.09, type: 'triangle', gain: 0.055 },
    { frequency: 783.99, start: 0.16, duration: 0.12, type: 'triangle', gain: 0.06 },
    { frequency: 1046.5, start: 0.28, duration: 0.22, type: 'sine', gain: 0.045 },
  ],
  endSession: [
    { frequency: 392, start: 0, duration: 0.08, type: 'triangle', gain: 0.052 },
    { frequency: 523.25, start: 0.075, duration: 0.1, type: 'triangle', gain: 0.055 },
    { frequency: 783.99, start: 0.17, duration: 0.16, type: 'sine', gain: 0.045 },
  ],
  playerRing: [
    { frequency: 659.25, start: 0, duration: 0.14, type: 'sine', gain: 0.06 },
    { frequency: 880, start: 0.14, duration: 0.18, type: 'sine', gain: 0.055 },
    { frequency: 1174.66, start: 0.31, duration: 0.28, type: 'sine', gain: 0.045 },
  ],
  playerTick: [
    { frequency: 1080, start: 0, duration: 0.045, type: 'square', gain: 0.035 },
    { frequency: 720, start: 0.025, duration: 0.05, type: 'triangle', gain: 0.025 },
  ],
  sentencePre: [
    { frequency: 392, start: 0, duration: 0.1, type: 'triangle', gain: 0.04 },
    { frequency: 588, start: 0.025, duration: 0.08, type: 'sine', gain: 0.022 },
  ],
  sentenceCard: [
    { frequency: 523.25, start: 0, duration: 0.1, type: 'triangle', gain: 0.04 },
    { frequency: 783.99, start: 0.025, duration: 0.08, type: 'sine', gain: 0.022 },
  ],
  sentenceAfter: [
    { frequency: 659.25, start: 0, duration: 0.11, type: 'triangle', gain: 0.04 },
    { frequency: 987.77, start: 0.025, duration: 0.09, type: 'sine', gain: 0.022 },
  ],
};

export function getSentenceCueSoundPattern(cue) {
  return EFFECTS[`sentence${String(cue || '').charAt(0).toUpperCase()}${String(cue || '').slice(1)}`] || [];
}

const NOTE_FREQUENCIES = {
  G4: 392,
  A4: 440,
  Bb4: 466.16,
  B4: 493.88,
  C5: 523.25,
  E4: 329.63,
  F4: 349.23,
  Fs4: 369.99,
};

const REPEAT_MELODIES = {
  4: ['G4', 'A4', 'Bb4', 'B4'],
  8: ['G4', 'E4', 'F4', 'Fs4', 'G4', 'A4', 'Bb4', 'B4'],
  12: ['G4', 'A4', 'Bb4', 'B4', 'C5', 'E4', 'F4', 'Fs4', 'G4', 'A4', 'Bb4', 'B4'],
  16: ['C5', 'A4', 'F4', 'C5', 'F4', 'G4', 'B4', 'C5', 'G4', 'B4', 'C5', 'B4', 'G4', 'A4', 'B4', 'C5'],
};

export function getRepeatSoundPattern({ repeatIndex, targetRepeats } = {}) {
  const safeTargetRepeats = Number(targetRepeats);
  const melody = REPEAT_MELODIES[safeTargetRepeats];
  if (!melody) return EFFECTS.repeat;

  const safeRepeatIndex = Math.max(1, Math.floor(Number(repeatIndex) || 1));
  const noteName = melody[(safeRepeatIndex - 1) % melody.length];
  const frequency = NOTE_FREQUENCIES[noteName];
  if (!frequency) return EFFECTS.repeat;

  return [
    { frequency, start: 0, duration: 0.058, type: 'triangle', gain: 0.058 },
    { frequency: frequency * 1.5, start: 0.04, duration: 0.068, type: 'sine', gain: 0.038 },
  ];
}

let audioContext = null;
const PRACTICE_SOUND_ENABLED_KEY = 'infinity-memoburst-practice-sound-enabled';
const PRACTICE_AUDIO_READY_EVENT = 'practiceAudioReadyChange';
const AUDIO_RECOVERY_GRACE_MS = 300;
const AUDIO_RESUME_TIMEOUT_MS = 1000;
let audioReady = false;
let audioUnlockPromise = null;
let audioUnlockStartedAt = 0;
let audioClockSample = null;
let audioNeedsRecovery = false;

function emitAudioReadyChange() {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(PRACTICE_AUDIO_READY_EVENT, {
    detail: { ready: audioReady },
  }));
}

function setAudioReady(nextReady) {
  if (audioReady === nextReady) return;
  audioReady = nextReady;
  emitAudioReadyChange();
}

function markAudioUnavailable() {
  audioNeedsRecovery = true;
  setAudioReady(false);
}

export function isPracticeSoundEnabled() {
  if (typeof localStorage === 'undefined') return true;
  return localStorage.getItem(PRACTICE_SOUND_ENABLED_KEY) !== 'false';
}

export function setPracticeSoundEnabled(enabled) {
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem(PRACTICE_SOUND_ENABLED_KEY, enabled ? 'true' : 'false');
  }
  if (!enabled) {
    markAudioUnavailable();
  }
}

export function isPracticeAudioReady() {
  return isPracticeSoundEnabled() && audioReady && !audioNeedsRecovery
    && audioContext?.state === 'running';
}

export function addPracticeAudioReadyListener(listener) {
  if (typeof window === 'undefined') return () => {};

  const handler = (event) => listener(Boolean(event.detail?.ready));
  window.addEventListener(PRACTICE_AUDIO_READY_EVENT, handler);
  return () => window.removeEventListener(PRACTICE_AUDIO_READY_EVENT, handler);
}

function getAudioContext() {
  if (typeof window === 'undefined') return null;

  const AudioContextClass = window.AudioContext || window.webkitAudioContext;
  if (!AudioContextClass) return null;

  if (!audioContext) {
    audioContext = new AudioContextClass();
    audioNeedsRecovery = false;
    audioClockSample = { time: audioContext.currentTime, checkedAt: performance.now() };
    const createdContext = audioContext;
    createdContext.onstatechange = () => {
      if (audioContext === createdContext) {
        setAudioReady(createdContext.state === 'running' && !audioNeedsRecovery);
      }
    };
  }

  return audioContext;
}

function discardAudioContext() {
  audioUnlockPromise = null;
  audioClockSample = null;
  if (!audioContext) return;

  const contextToClose = audioContext;
  audioContext = null;
  contextToClose.onstatechange = null;
  setAudioReady(false);

  try {
    if (contextToClose.state !== 'closed') {
      const closeResult = contextToClose.close();
      closeResult?.catch?.(() => {});
    }
  } catch (error) {
    // Some iOS WebViews throw while closing an interrupted context. Recreate anyway.
  }
}

function isAudioClockStalled(now) {
  if (!audioContext || audioContext.state !== 'running') return false;
  const time = audioContext.currentTime;
  if (!audioClockSample || time !== audioClockSample.time) {
    audioClockSample = { time, checkedAt: now };
    return false;
  }
  // Check only on taps, allowing for startup and browsers with rounded clocks.
  return now - audioClockSample.checkedAt >= AUDIO_RECOVERY_GRACE_MS;
}

async function resumeAudioContext(context) {
  let timeout;
  try {
    return await Promise.race([
      context.resume().then(() => true),
      new Promise((resolve) => {
        timeout = setTimeout(() => resolve(false), AUDIO_RESUME_TIMEOUT_MS);
      }),
    ]);
  } catch (error) {
    return false;
  } finally {
    clearTimeout(timeout);
  }
}

function playUnlockPulse(context) {
  const now = context.currentTime;
  const oscillator = context.createOscillator();
  const gainNode = context.createGain();

  oscillator.type = 'sine';
  oscillator.frequency.setValueAtTime(440, now);
  gainNode.gain.setValueAtTime(0.0001, now);
  gainNode.gain.exponentialRampToValueAtTime(0.004, now + 0.01);
  gainNode.gain.exponentialRampToValueAtTime(0.0001, now + 0.04);
  oscillator.connect(gainNode);
  gainNode.connect(context.destination);
  oscillator.start(now);
  oscillator.stop(now + 0.05);
}

async function performAudioUnlock({ playTestPulse = false, forceEnabled = false } = {}) {
  let context;
  try {
    if (!forceEnabled && !isPracticeSoundEnabled()) {
      setAudioReady(false);
      return false;
    }

    context = getAudioContext();
    if (!context) return false;

    // WebKit adds an `interrupted` state after calls, app switching, or competing
    // media playback. It must not be treated as playable even though it is neither
    // suspended nor closed. Recreate it synchronously while we still have the tap.
    if (context.state === 'interrupted' || context.state === 'closed') {
      discardAudioContext();
      context = getAudioContext();
      if (!context) return false;
    }

    if (context.state !== 'running') {
      const resumed = await resumeAudioContext(context);
      if (context !== audioContext) return false;
      if (!resumed) {
        markAudioUnavailable();
        return false;
      }
    }

    const ready = context.state === 'running' && (forceEnabled || isPracticeSoundEnabled());
    if (ready) setAudioReady(!audioNeedsRecovery);
    else markAudioUnavailable();

    if (ready && playTestPulse) {
      playUnlockPulse(context);
    }

    return ready;
  } catch (error) {
    console.log('Audio play blocked:', error);
    if (context === audioContext) markAudioUnavailable();
    return false;
  }
}

export function unlockPracticeAudio(options = {}) {
  if (!options.forceEnabled && !isPracticeSoundEnabled()) return Promise.resolve(false);

  const now = performance.now();
  const pendingUnlockStalled = audioUnlockPromise
    && now - audioUnlockStartedAt >= AUDIO_RECOVERY_GRACE_MS;
  const recoverFromGesture = options.recoverOnGesture && (
    audioNeedsRecovery || audioContext?.state === 'interrupted' || audioContext?.state === 'closed'
    || isAudioClockStalled(now) || pendingUnlockStalled
  );
  // Recovery must happen inside the gesture, even if an older resume never settled.
  if (options.forceReset || recoverFromGesture) discardAudioContext();

  // Several handlers unlock and play in the same tap. Share that attempt so two
  // asynchronous recovery paths cannot close and replace each other's context.
  if (audioUnlockPromise) return audioUnlockPromise;

  const unlockAttempt = performAudioUnlock(options);
  audioUnlockPromise = unlockAttempt;
  audioUnlockStartedAt = now;
  unlockAttempt.finally(() => {
    if (audioUnlockPromise === unlockAttempt) {
      audioUnlockPromise = null;
    }
  });
  return unlockAttempt;
}

function playTone(context, { frequency, start, duration, type, gain }, signal) {
  const now = context.currentTime;
  const oscillator = context.createOscillator();
  const gainNode = context.createGain();
  const startAt = now + start;
  const endAt = startAt + duration;

  oscillator.type = type;
  oscillator.frequency.setValueAtTime(frequency, startAt);
  gainNode.gain.setValueAtTime(0.0001, startAt);
  gainNode.gain.exponentialRampToValueAtTime(gain, startAt + 0.012);
  gainNode.gain.exponentialRampToValueAtTime(0.0001, endAt);

  oscillator.connect(gainNode);
  gainNode.connect(context.destination);
  oscillator.start(startAt);
  oscillator.stop(endAt + 0.02);

  if (signal) {
    const stop = () => {
      try { oscillator.stop(); } catch { /* The short tone may already have ended. */ }
      oscillator.disconnect?.();
      gainNode.disconnect?.();
      signal.removeEventListener('abort', stop);
    };
    signal.addEventListener('abort', stop, { once: true });
    oscillator.onended = () => {
      signal.removeEventListener('abort', stop);
      oscillator.disconnect?.();
      gainNode.disconnect?.();
    };
  }
}

export function playResultStepSound(step, { signal, totalSteps = 4 } = {}) {
  // An original quiz-show chime: a downward "ding-dong", then a bright tonic finish.
  // The optional fifth metric gets an extra pickup, keeping the final C at the end.
  const melody = totalSteps === 5
    ? [659.25, 523.25, 659.25, 783.99, 1046.5] // E C E G C
    : [659.25, 523.25, 783.99, 1046.5]; // E C G C
  if (!Number.isInteger(step) || step < 0 || step >= melody.length) return;
  const frequency = melody[step];
  if (!frequency || signal?.aborted || document.hidden || !isPracticeSoundEnabled()) return;
  try {
    const context = getAudioContext();
    // Never await autoplay permission here: a late note would miss its reveal.
    // Practice gestures already unlock this context; blocked devices stay silent.
    if (!context || context.state !== 'running') return;
    const finalNote = step === melody.length - 1;
    // A quiet fundamental plus two short overtones gives each note a bell attack.
    // Only the final fundamental lingers; no loading, extra timers or navigation delay.
    [
      { frequency, duration: finalNote ? 0.48 : 0.22, gain: 0.045 },
      { frequency: frequency * 2, duration: finalNote ? 0.18 : 0.10, gain: 0.014 },
      { frequency: frequency * 3, duration: finalNote ? 0.10 : 0.06, gain: 0.004 },
    ].forEach(tone => playTone(context, { ...tone, start: 0, type: 'sine' }, signal));
  } catch {
    // Decorative result audio must not affect navigation or saved results.
  }
}

export async function playPracticeSound(effectName, options = {}) {
  if (!options.force && !isPracticeSoundEnabled()) return;

  const pattern = effectName === 'repeat'
    ? getRepeatSoundPattern(options)
    : EFFECTS[effectName];
  if (!pattern) return;

  try {
    const unlocked = await unlockPracticeAudio({
      forceEnabled: Boolean(options.force),
      recoverOnGesture: Boolean(options.recoverOnGesture),
    });
    if (!unlocked || (!options.force && !isPracticeSoundEnabled())) return;

    // Unlock may replace an interrupted WebKit context. Always fetch the current
    // instance instead of scheduling tones on the stale, silent context.
    const context = getAudioContext();
    if (!context || context.state !== 'running') return;

    setAudioReady(!audioNeedsRecovery);
    pattern.forEach((tone) => playTone(context, tone));
  } catch (error) {
    console.log('Audio play blocked:', error);
    markAudioUnavailable();
    // Audio is decorative. Browser autoplay or device restrictions should never break practice.
  }
}

if (typeof document !== 'undefined') {
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) {
      markAudioUnavailable();
    }
  });
}

if (typeof window !== 'undefined') {
  window.addEventListener('pageshow', markAudioUnavailable);
  window.addEventListener('focus', markAudioUnavailable);
}
